import { useState } from "react";
import useFetch from "../../../../hooks/useFetch";

export default function useQuestionStatusPie() {
  const { request, loading } = useFetch();
  const [data, setData] = useState([]);

  const fetchData = async (url) => {
    const res = await request(url);
    if (res?.data) {
      const d = res.data.questionsAttemptStats[0];
      setData([
        { name: "Correct", value: d.correct },
        { name: "Incorrect", value: d.incorrect },
        { name: "Unattempted", value: d.unattempted },
      ]);
    }
  };

  return { data, loading, fetchData };
}